import React from 'react'
import { Heading, LayoutPageWrapper } from 'goustouicomponents'
import teamImage1 from '../../assets/images/Career_Page_Images_Square_01.jpg'
import teamImage2 from '../../assets/images/Career_Page_Images_Square_02.jpg'
import teamImage3 from '../../assets/images/Career_Page_Images_Square_03.jpg'
import css from './OurTeam.module.css'

const OurTeam = () => (
  <section>
    <LayoutPageWrapper padding="large-screens-only">
      <div className={css.textWrapper}>
        <Heading type="h2" size="fontStyleXL">
          Meet our teams
        </Heading>
        <p className={css.mainText}>
          Our office is buzzing with different cultures and backgrounds and that’s exactly how we like it. We’re hungry
          for new ideas and fresh insight - could you be the one to bring it to the table?
        </p>
      </div>
      <div className={css.imageContainer}>
        <img className={css.teamMembersImage} src={teamImage3} alt="Gousto employee" />
        <img className={css.teamMembersImage} src={teamImage1} alt="Gousto employee" />
        <img className={css.teamMembersImage} src={teamImage2} alt="Gousto employee" />
      </div>
    </LayoutPageWrapper>
  </section>
)

export { OurTeam }
